@if (data$ | async; as data) {
  @if (isPikatukku()) {
    <div class="footer-notification">
      @if (openingHours$ | async; as openingHours) {
        <div class="container">
          <div class="row align-items-center">
            <div class="col-12 col-md-8">
              <div class="d-inline-block mr-2">
                @if (data.openingHoursDescription) {
                  <div [innerHTML]="data.openingHoursDescription">
                    {{ data.openingHoursDescription }}
                  </div>
                }
              </div>
              @for (op of openingHours; track op.location) {
                <div class="d-inline-block mr-2">
                  @if (op.activeDay) {
                    <div class="d-inline-block text-bold">
                      {{ op.location }}:
                      @if (!op.activeDay.closed) {
                        <span
                          >{{ op.activeDay.opening_hour }}-{{ op.activeDay.closing_hour }}</span
                          >
                        }
                        @if (op.activeDay.closed) {
                          <span>{{ 'aimo.pikatukku.closed' | cxTranslate }}</span>
                        }
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="col-12 col-md-4 text-md-right">
                @if (data.openingHoursException && data.openingHoursExceptionUrl) {
                  <a
                    [href]="data.openingHoursExceptionUrl"
                    target="_blank"
                    class="text-underline"
                    >{{ data.openingHoursException }}</a
                    >
                  }
                </div>
              </div>
            </div>
          }
        </div>
      }
      <div class="footer {{ data.styleClasses }}">
        <div class="container">
          <div class="row footer-top-navigation">
            <div class="col-12 col-md-2">
              <cx-page-slot position="SiteLogo"></cx-page-slot>
            </div>
            <div class="col-6 col-md-2">
              @if (storeGroupNavNode$ | async; as storeNavNode) {
                <ng-container *ngTemplateOutlet="footerNavGroup; context: { node: storeNavNode }">
                </ng-container>
              }
            </div>
            <div class="col-6 col-md-2">
              @if (customerServiceGroupNavNode$ | async; as customerServiceNavNode) {
                <ng-container *ngTemplateOutlet="footerNavGroup; context: { node: customerServiceNavNode }">
                </ng-container>
              }
            </div>
            <div class="col-6 col-md-2">
              <div class="footer-navigation-column">
                <div class="footer-navigation-group">
                  <div class="footer-navigation-group-list" [innerHTML]="data.companyInfo">
                    {{ data.companyInfo }}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-6 col-md-2">
              @if (valioAimoGroupNavNode$ | async; as valioAimoNavNode) {
                <ng-container *ngTemplateOutlet="footerNavGroup; context: { node: valioAimoNavNode }">
                </ng-container>
              }
            </div>
            <div class="col-12 col-md-2">
              @if (someNavNode$ | async; as someNavigationNode) {
                @if (someNavigationNode.children?.length > 0) {
                  <ul class="footer-top-content-social-media">
                    @for (child of someNavigationNode.children; track child.uid) {
                      @for (childnode of child.children; track childnode.uid) {
                        <li>
                          @if (
                            childnode.url &&
                            (!childnode.children || childnode.children?.length === 0)
                            ) {
                            <cx-generic-link
                              [url]="childnode.url"
                              [target]="childnode.target"
                              [class]="childnode.styleClasses">
                              {{ childnode.title }}
                            </cx-generic-link>
                          }
                        </li>
                      }
                    }
                  </ul>
                }
              }
            </div>
          </div>
          <div class="row footer-bottom-copyright">
            <div class="col-12 col-md-6">
              <p>{{ data.notice }}</p>
            </div>
            <div class="col-12 col-md-6 text-md-right">
              @if (legalNavNode$ | async; as bottomNavigationNode) {
                @if (bottomNavigationNode.children?.length > 0) {
                  @for (child of bottomNavigationNode.children; track child.uid) {
                    @for (childnode of child.children; track childnode.uid) {
                      @if (
                        childnode.url && (!childnode.children || childnode.children?.length === 0)
                        ) {
                        <cx-generic-link
                          [url]="childnode.url"
                          [target]="childnode.target"
                          [class]="childnode.styleClasses">
                          {{ childnode.title }}
                        </cx-generic-link>
                      }
                    }
                  }
                }
              }
            </div>
          </div>
        </div>
      </div>
    }

    <ng-template #footerNavGroup let-node="node">
      @if (node.children?.length > 0) {
        <div class="footer-navigation-column">
          <div class="footer-navigation-group">
            @for (child of node.children; track child.uid) {
              <div class="footer-navigation-group-list">
                <ul>
                  @for (childnode of child.children; track childnode.uid) {
                    @if (!childnode.url && childnode.styleClasses) {
                      <li class="{{ childnode.styleClasses }}">
                        @if (!childnode.url) {
                          <span>{{ childnode.title }}</span>
                        }
                      </li>
                    } @else {
                      <li class="{{ childnode.styleClasses }}">
                        @if (
                          childnode.url &&
                          (!childnode.children || childnode.children?.length === 0)
                          ) {
                          <cx-generic-link
                            [url]="childnode.url"
                            [target]="childnode.target">
                            {{ childnode.title }}
                          </cx-generic-link>
                        }
                      </li>
                    }
                  }
                </ul>
              </div>
            }
          </div>
        </div>
      }
    </ng-template>

    <aimo-product-comparison-preview></aimo-product-comparison-preview>
